type ENV = "dev" | "prod" | "demo";

export const currentEnv: string = "prod";

const env: string = currentEnv;

export const Env = env;

const API_DEV_URL = "https://easy-market-api.withvolkeno.com";
const API_DEMO_URL = "https://easy-market-api.withvolkeno.com";
const API_PROD_URL = "https://api.easymarket.sn";

const VENDEUR_APIKEY_DEMO =
  "fcd24ffd742c6c29492b798ad4fdaffd35cf1453026ff424c0ab2c302fb68eda";
const VENDEUR_APIKEY_PROD =
  "fcd24ffd742c6c29492b798ad4fdaffd35cf1453026ff424c0ab2c302fb68eda";

export const APP_URL_DEV = "https://easy-market.volkeno.com/";
export const APP_URL_DEMO = "https://yeksinahome.com/";
export const APP_URL_PROD = "https://yeksinahome.com/";

function processApiUrl() {
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl() {
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey() {
  if (env === "prod") return VENDEUR_APIKEY_PROD;
  if (env === "demo") return VENDEUR_APIKEY_DEMO;
  return VENDEUR_APIKEY_DEMO;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyChXWZKmUgaWFvIV2WnTVoR2lY3-uhReBg";

export const IntechApikey = "";

export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";